import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';


export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router: Router = inject(Router);
  var retrieve = localStorage.getItem('authorizationData');
  let authObj = { accessToken: '' }
  if (retrieve) {
    authObj = JSON.parse(retrieve);
  }
  return authObj.accessToken.length > 0  ? true : router.navigate([ '/login' ]);
};
